export default __webpack_public_path__ + "static/media/kiiper_check.2239fdac.svg";